import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73630d3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pdca-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ph-title" }, "PDCA 改善课题管理"),
  /*#__PURE__*/_createElementVNode("div", { class: "ph-sub" }, "一个 PDCA 循环一条课题，课题链滚动推进。系统硬门禁：无基线不立项 · 无证据不转 C · 无标准不关闭。")
], -1))
const _hoisted_3 = { class: "stat-row" }
const _hoisted_4 = { class: "stat-card" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "s-label" }, "问题池待立项", -1))
const _hoisted_6 = { class: "s-value" }
const _hoisted_7 = { class: "stat-card" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "s-label" }, "进行中课题", -1))
const _hoisted_9 = { class: "s-value" }
const _hoisted_10 = { class: "stat-card warn" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "s-label" }, "逾期课题", -1))
const _hoisted_12 = { class: "s-value" }
const _hoisted_13 = { class: "stat-card ok" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "s-label" }, "已关闭课题", -1))
const _hoisted_15 = { class: "s-value" }
const _hoisted_16 = { class: "stat-card money" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "s-label" }, "节约金额(元)", -1))
const _hoisted_18 = { class: "s-value" }
const _hoisted_19 = { class: "toolbar" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("录入课题")
const _hoisted_23 = { class: "table-card" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("逾期")
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("问题池")
const _hoisted_31 = { class: "toolbar" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#909399","font-size":"13px"} }, "多入口汇聚的原始问题。补齐 P 阶段三要素（根因 / 指标 / 基线）即可立项——无基线不立项。", -1))
const _hoisted_33 = /*#__PURE__*/_createTextVNode("录入问题")
const _hoisted_34 = { class: "table-card" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("处理")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("完善并立项")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("我的任务")
const _hoisted_39 = { class: "table-card" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("开始执行")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("标记完成")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("看课题")
const _hoisted_43 = { class: "kanban-grid" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "k-label" }
const _hoisted_46 = {
  class: "kanban-col",
  style: {"border-top":"3px solid #f56c6c"}
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "k-label" }, "逾期", -1))
const _hoisted_48 = {
  class: "k-count",
  style: {"color":"#f56c6c"}
}
const _hoisted_49 = { class: "gate-tip" }
const _hoisted_50 = {
  key: 0,
  class: "table-card"
}
const _hoisted_51 = { style: {"color":"#67c23a"} }
const _hoisted_52 = { style: {"color":"#f56c6c"} }
const _hoisted_53 = {
  class: "table-card",
  style: {"box-shadow":"none","border":"1px solid #ebeef5"}
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"600","margin-bottom":"10px"} }, "按问题来源", -1))
const _hoisted_55 = {
  class: "table-card",
  style: {"box-shadow":"none","border":"1px solid #ebeef5"}
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"600","margin-bottom":"10px"} }, "按课题层级", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c","margin-right":"4px"} }, "*", -1))
const _hoisted_58 = /*#__PURE__*/_createTextVNode("课题标题")
const _hoisted_59 = { style: {"width":"100%"} }
const _hoisted_60 = { style: {"color":"#909399","width":"20px","text-align":"center"} }
const _hoisted_61 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_62 = /*#__PURE__*/_createTextVNode("+ 添加指标")
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#909399","font-size":"12px","line-height":"1.5"} }, "可添加多个指标；目标<基线为下降型(如不良率)，目标>基线为上升型(如准确率)。立项时每个指标须填全基线值与目标值。", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gate-tip" }, "立项门禁：问题陈述、根因分析、验证指标、基线值、目标值、计划完成日期缺一不可——无基线不立项。", -1))
const _hoisted_65 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_66 = /*#__PURE__*/_createTextVNode("存入问题池")
const _hoisted_67 = { key: 0 }
const _hoisted_68 = { style: {"display":"flex","align-items":"center","gap":"8px","margin-bottom":"14px"} }
const _hoisted_69 = /*#__PURE__*/_createTextVNode("逾期")
const _hoisted_70 = { style: {"color":"#909399","font-size":"13px"} }
const _hoisted_71 = {
  key: 0,
  class: "chain-box"
}
const _hoisted_72 = { key: 0 }
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" ← 下一轮 ")
const _hoisted_74 = ["onClick"]
const _hoisted_75 = { key: 1 }
const _hoisted_76 = { style: {"width":"100%"} }
const _hoisted_77 = { style: {"color":"#909399","width":"20px","text-align":"center"} }
const _hoisted_78 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_79 = /*#__PURE__*/_createTextVNode("+ 添加指标")
const _hoisted_80 = /*#__PURE__*/_createTextVNode("保存计划")
const _hoisted_81 = { style: {"margin-top":"18px"} }
const _hoisted_82 = { style: {"display":"flex","align-items":"center","justify-content":"space-between","margin-bottom":"8px"} }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "对策计划（D 阶段执行清单）", -1))
const _hoisted_84 = /*#__PURE__*/_createTextVNode("新增对策")
const _hoisted_85 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_86 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_87 = {
  key: 2,
  class: "gate-tip"
}
const _hoisted_88 = /*#__PURE__*/_createTextVNode(" 进入 D 执行门禁：目标三件套（指标/基线/目标）+ 根因 + 计划完成日 + 至少一条对策。 ")
const _hoisted_89 = /*#__PURE__*/_createTextVNode("开始执行(D)")
const _hoisted_90 = {
  key: 0,
  style: {"font-size":"12px","color":"#333","word-break":"break-all"}
}
const _hoisted_91 = {
  key: 1,
  style: {"display":"flex","flex-wrap":"wrap","gap":"4px","margin-top":"4px","align-items":"center"}
}
const _hoisted_92 = ["href"]
const _hoisted_93 = {
  key: 2,
  style: {"color":"#bbb"}
}
const _hoisted_94 = /*#__PURE__*/_createTextVNode("开始")
const _hoisted_95 = /*#__PURE__*/_createTextVNode("完成")
const _hoisted_96 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_97 = {
  key: 0,
  class: "gate-tip"
}
const _hoisted_98 = /*#__PURE__*/_createTextVNode(" 进入 C 检查门禁：全部对策完成且每条挂完成证据——无证据不转 C。 ")
const _hoisted_99 = /*#__PURE__*/_createTextVNode("全部完成，进入C检查")
const _hoisted_100 = { key: 0 }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#606266","font-size":"13px","margin-bottom":"10px"} }, "逐指标录入改善后实测值：目标<基线为下降型(实测≤目标达标)，目标>基线为上升型(实测≥目标达标)。全部达标→达标，部分→部分达标，全未达标→需打回P。", -1))
const _hoisted_102 = /*#__PURE__*/_createTextVNode("达标")
const _hoisted_103 = /*#__PURE__*/_createTextVNode("未达标")
const _hoisted_104 = {
  key: 2,
  style: {"color":"#909399"}
}
const _hoisted_105 = { style: {"margin-bottom":"12px"} }
const _hoisted_106 = /*#__PURE__*/_createTextVNode("整体结论：")
const _hoisted_107 = /*#__PURE__*/_createTextVNode("确认结论，进入A处理")
const _hoisted_108 = /*#__PURE__*/_createTextVNode("未达标，打回P重析根因")
const _hoisted_109 = { key: 1 }
const _hoisted_110 = /*#__PURE__*/_createTextVNode("达标")
const _hoisted_111 = /*#__PURE__*/_createTextVNode("未达标")
const _hoisted_112 = {
  key: 2,
  style: {"color":"#909399"}
}
const _hoisted_113 = { style: {"display":"flex","align-items":"center","justify-content":"space-between","margin-bottom":"8px"} }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "标准化产出（关闭门禁：无标准不关闭）", -1))
const _hoisted_115 = /*#__PURE__*/_createTextVNode("登记标准")
const _hoisted_116 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_117 = {
  key: 0,
  style: {"margin-top":"14px"}
}
const _hoisted_118 = /*#__PURE__*/_createTextVNode("关闭课题（已挂标准或已派生下一轮）")
const _hoisted_119 = /*#__PURE__*/_createTextVNode("遗留问题 → 生成下一轮课题")
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gate-tip" }, "关闭门禁：登记至少一条标准化产出（SOP/制度/参数），或派生下一轮课题后自动关闭父课题。", -1))
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c","margin-right":"4px"} }, "*", -1))
const _hoisted_122 = /*#__PURE__*/_createTextVNode("对策内容")
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c","margin-right":"4px"} }, "*", -1))
const _hoisted_124 = /*#__PURE__*/_createTextVNode("责任人")
const _hoisted_125 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_126 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_127 = { style: {"color":"#666","font-size":"13px","margin-top":"0"} }
const _hoisted_128 = { style: {"margin-top":"12px"} }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"13px","color":"#333","margin-bottom":"8px"} }, [
  /*#__PURE__*/_createTextVNode("附件：点击选择 / 拖拽到下方区域 / "),
  /*#__PURE__*/_createElementVNode("b", null, "Ctrl+V 粘贴截图"),
  /*#__PURE__*/_createTextVNode("（单个≤5MB，可多个）")
], -1))
const _hoisted_130 = ["onDragleave", "onDrop"]
const _hoisted_131 = { style: {"display":"flex","flex-wrap":"wrap","gap":"8px","align-items":"flex-start"} }
const _hoisted_132 = ["href"]
const _hoisted_133 = /*#__PURE__*/_createTextVNode("×")
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"88px","height":"88px","border":"1px dashed #d9d9d9","border-radius":"6px","display":"flex","align-items":"center","justify-content":"center","cursor":"pointer","color":"#8c939d","font-size":"26px","line-height":"1"} }, "+", -1))
const _hoisted_135 = {
  key: 0,
  style: {"color":"#8c939d","font-size":"12px","margin-top":"6px"}
}
const _hoisted_136 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_137 = /*#__PURE__*/_createTextVNode("确认完成")
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c","margin-right":"4px"} }, "*", -1))
const _hoisted_139 = /*#__PURE__*/_createTextVNode("标准编号")
const _hoisted_140 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_141 = /*#__PURE__*/_createTextVNode("登记")
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c","margin-right":"4px"} }, "*", -1))
const _hoisted_143 = /*#__PURE__*/_createTextVNode("新课题标题")
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gate-tip" }, "生成后父课题自动关闭（关闭门禁豁免），新课题进入问题池，重新走 P 计划。", -1))
const _hoisted_145 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_146 = /*#__PURE__*/_createTextVNode("生成下一轮")

import { ref, reactive, computed, onMounted, onBeforeUnmount } from 'vue';
	import { ElMessage, ElMessageBox } from 'element-plus';
	import axios from 'axios';
	import { apiName } from '@/api/api';
	import { xmUser } from '@/api/xmApi';
	import { requestgetselfrole } from '@/api/api';
	import {
		reqPdcaDicts, reqPdcaItemList, reqPdcaItemDetail, reqPdcaItemSave, reqPdcaItemDelete,
		reqPdcaItemTransition, reqPdcaItemClose, reqPdcaItemNextCycle,
		reqPdcaActionSave, reqPdcaActionDelete, reqPdcaActionStatus, reqPdcaActionMyList,
		reqPdcaStandardSave, reqPdcaStandardDelete, reqPdcaKanban, reqPdcaReport
	} from '@/api/pdcaApi';

	
export default /*#__PURE__*/_defineComponent({
  name: 'pdca',
  setup(__props) {

	const api = ref<string>(apiName)

	const statusMeta: any = {
		draft:     { label: '问题池',  tag: 'info',    color: '#909399' },
		planning:  { label: 'P·计划',  tag: '',        color: '#409eff' },
		doing:     { label: 'D·执行',  tag: 'warning', color: '#e6a23c' },
		checking:  { label: 'C·检查',  tag: 'warning', color: '#b88230' },
		acting:    { label: 'A·处理',  tag: 'danger',  color: '#f56c6c' },
		closed:    { label: '已关闭',  tag: 'success', color: '#67c23a' }
	};
	const actionStatusMap: any = { todo: '待处理', doing: '进行中', done: '已完成', cancelled: '已取消' };
	const statusOptions = Object.keys(statusMeta).map(k => ({ value: k, label: statusMeta[k].label, color: statusMeta[k].color }));
	const statusLabel = (s: any) => (statusMeta[s] ? statusMeta[s].label : s);
	const actionStatusLabel = (s: any) => actionStatusMap[s] || s;

	// 权限：登录用户可编辑，管理员可删除
	const canEdit = ref(true)
	const canDelete = ref(false)

	// 字典与用户
	const dicts = reactive<any>({ sources: [], levels: [], std_types: [] })
	const userOptions = ref<any[]>([])
	const loadDicts = () => {
		reqPdcaDicts({}).then((res: any) => {
			if (res.status === 1 && res.datalist) {
				dicts.sources = res.datalist.sources || []
				dicts.levels = res.datalist.levels || []
				dicts.std_types = res.datalist.std_types || []
			}
		})
	}
	const loadUsers = () => {
		xmUser({}).then((res: any) => { if (res.status === 1) userOptions.value = res.datalist || [] })
	}
	const loadRole = () => {
		requestgetselfrole({}).then((res: any) => {
			if (res.status === 1) canDelete.value = res.datalist === '管理员'
		})
	}

	// 统计
	const kanban = reactive<any>({ by_status: {}, overdue: 0, my_open: 0 })
	const report = ref<any>(null)
	const openCount = computed(() =>
		Number(kanban.by_status['planning'] || 0) + Number(kanban.by_status['doing'] || 0) +
		Number(kanban.by_status['checking'] || 0) + Number(kanban.by_status['acting'] || 0))
	const savingText = computed(() => report.value ? Number(report.value.saving_total || 0).toLocaleString() : '-')
	const loadKanban = () => { reqPdcaKanban({}).then((res: any) => { if (res.status === 1) Object.assign(kanban, res.datalist || {}) }) }
	const loadReport = () => { reqPdcaReport({}).then((res: any) => { if (res.status === 1) report.value = res.datalist }) }

	// 列表
	const activeTab = ref('list')
	const searchForm = reactive<any>({ keyword: '', status: '', source_type: '', level: '', mine: false, page_size: 20 })
	const currentPage = ref(1)
	const total = ref(0)
	const listData = ref<any[]>([])
	const loading = ref(false)
	const loadList = () => {
		loading.value = true
		reqPdcaItemList({
			page: currentPage.value, page_size: searchForm.page_size,
			keyword: searchForm.keyword || '', status: searchForm.status || '',
			source_type: searchForm.source_type || '', level: searchForm.level || '',
			mine: searchForm.mine ? '1' : '0'
		}).then((res: any) => {
			if (res.status === 1 && res.datalist) {
				listData.value = res.datalist.list || []
				total.value = res.datalist.total || 0
			} else {
				ElMessage.error(res.msg || '查询失败')
			}
		}).finally(() => { loading.value = false })
	}
	const resetSearch = () => {
		searchForm.keyword = ''; searchForm.status = ''; searchForm.source_type = ''; searchForm.level = ''; searchForm.mine = false
		currentPage.value = 1; loadList()
	}
	const handlePageChange = (p: number) => { currentPage.value = p; loadList() }
	const handleSizeChange = (s: number) => { searchForm.page_size = s; currentPage.value = 1; loadList() }
	const jumpStatus = (s: string) => { searchForm.status = s; activeTab.value = 'list'; currentPage.value = 1; loadList() }

	// 问题池
	const poolData = ref<any[]>([])
	const poolLoading = ref(false)
	const loadPool = () => {
		poolLoading.value = true
		reqPdcaItemList({ status: 'draft', page: 1, page_size: 100 }).then((res: any) => {
			if (res.status === 1 && res.datalist) poolData.value = res.datalist.list || []
		}).finally(() => { poolLoading.value = false })
	}

	// 我的任务
	const myTasks = ref<any[]>([])
	const myLoading = ref(false)
	const loadMy = () => {
		myLoading.value = true
		reqPdcaActionMyList({}).then((res: any) => {
			myTasks.value = (res.status === 1 && Array.isArray(res.datalist)) ? res.datalist : []
		}).finally(() => { myLoading.value = false })
	}

	// 新增/编辑课题
	const formVisible = ref(false)
	const submitting = ref(false)
	const newMetric = () => ({ id: 0, metric_name: '', base_value: null, target_value: null })
	const addMetricRow = (arr: any[]) => { arr.push(newMetric()) }
	const removeMetricRow = (arr: any[], idx: number) => { if (arr.length > 1) arr.splice(idx, 1); else arr.splice(0, 1, newMetric()) }
	const emptyForm = () => ({ id: 0, title: '', source_type: '', level: '', dept_name: '', owner_name: '', plan_deadline: '', problem_desc: '', root_cause: '', metrics: [newMetric()] })
	const form = ref<any>(emptyForm())
	const openForm = (row: any) => {
		const f = emptyForm()
		if (row) {
			f.id = row.id; f.title = row.title; f.source_type = row.source_type; f.level = row.level
			f.dept_name = row.dept_name; f.owner_name = row.owner_name; f.plan_deadline = row.plan_deadline
			f.problem_desc = row.problem_desc || ''; f.root_cause = row.root_cause || ''
		}
		form.value = f
		formVisible.value = true
		if (row && row.id) {
			reqPdcaItemDetail({ id: row.id }).then((res: any) => {
				if (res.status === 1 && res.datalist) {
					const ms = (res.datalist.metrics || []).map((m: any) => ({
						id: m.id, metric_name: m.metric_name,
						base_value: m.base_value === null || m.base_value === '' ? null : Number(m.base_value),
						target_value: m.target_value === null || m.target_value === '' ? null : Number(m.target_value)
					}))
					form.value.metrics = ms.length ? ms : [newMetric()]
				}
			})
		}
	}
	const submitForm = (status: string) => {
		const f = form.value
		if (!f.title || !f.title.trim()) { ElMessage.warning('请输入课题标题'); return }
		const metrics = (f.metrics || []).filter((m: any) => (m.metric_name && m.metric_name.trim()) || m.base_value !== null || m.target_value !== null)
		if (status === 'planning') {
			if (!metrics.length) { ElMessage.warning('立项至少需要一个验证指标(无基线不立项)'); return }
			for (let i = 0; i < metrics.length; i++) {
				const m = metrics[i]
				if (!m.metric_name || !m.metric_name.trim()) { ElMessage.warning('第' + (i + 1) + '个指标名称不能为空'); return }
				if (m.base_value === null || m.base_value === undefined) { ElMessage.warning('指标【' + m.metric_name + '】需填写基线值'); return }
				if (m.target_value === null || m.target_value === undefined) { ElMessage.warning('指标【' + m.metric_name + '】需填写目标值'); return }
			}
		}
		submitting.value = true
		reqPdcaItemSave({
			id: f.id, title: f.title, source_type: f.source_type, level: f.level, dept_name: f.dept_name,
			owner_name: f.owner_name, plan_deadline: f.plan_deadline, problem_desc: f.problem_desc,
			root_cause: f.root_cause, status: status, metrics: JSON.stringify(metrics)
		}).then((res: any) => {
			if (res.status === 1) {
				ElMessage.success(status === 'draft' ? '已存入问题池' : '立项成功')
				formVisible.value = false
				refreshAll()
			} else ElMessage.error(res.msg || '保存失败')
		}).finally(() => { submitting.value = false })
	}
	const handleDeleteItem = (row: any) => {
		ElMessageBox.confirm('确认删除课题「' + row.title + '」？仅问题池/计划状态可删除。', '提示', { type: 'warning' }).then(() => {
			reqPdcaItemDelete({ id: row.id }).then((res: any) => {
				if (res.status === 1) { ElMessage.success('已删除'); refreshAll() } else ElMessage.error(res.msg)
			})
		}).catch(() => {})
	}

	// 详情
	const detailVisible = ref(false)
	const detailTab = ref('P')
	const detail = ref<any>(null)
	const pEditable = computed(() => detail.value && canEdit.value && ['draft', 'planning'].includes(detail.value.item.status))
	const stepActive = computed(() => {
		if (!detail.value) return 0
		const map: any = { draft: 0, planning: 1, doing: 2, checking: 3, acting: 4, closed: 4 }
		return map[detail.value.item.status] || 0
	})
	const pForm = reactive<any>({ metrics: [] })
	const checkForm = reactive<any>({ side_effect: '', check_note: '' })
	const closeForm = reactive<any>({ saving_amount: null })
	const checkMetrics = ref<any[]>([])
	const num = (v: any) => (v === null || v === undefined || v === '' ? null : Number(v))
	const metricJudge = (row: any) => {
		const b = num(row.base_value), t = num(row.target_value), a = num(row.after_value)
		if (a === null || t === null) return ''
		if (b === null) return a >= t ? '达标' : '未达标'
		if (t < b) return a <= t ? '达标' : '未达标'
		if (t > b) return a >= t ? '达标' : '未达标'
		return a === t ? '达标' : '未达标'
	}
	const overallConclusion = computed(() => {
		const rows = checkMetrics.value || []
		if (!rows.length) return ''
		let judged = 0, hit = 0
		rows.forEach((r: any) => { const j = metricJudge(r); if (j) { judged++; if (j === '达标') hit++ } })
		if (!judged) return ''
		if (hit === judged) return '达标'
		if (hit === 0) return '未达标'
		return '部分达标'
	})
	const overallTagType = computed(() => {
		const c = overallConclusion.value
		return c === '达标' ? 'success' : (c === '部分达标' ? 'warning' : (c === '未达标' ? 'danger' : 'info'))
	})
	const canEnterActing = computed(() => {
		const rows = checkMetrics.value || []
		if (!rows.length) return false
		const allFilled = rows.every((r: any) => num(r.after_value) !== null)
		const oc = overallConclusion.value
		return allFilled && (oc === '达标' || oc === '部分达标')
	})
	const openDetail = (row: any) => openDetailById(row.id)
	const openDetailById = (id: any) => {
		detailVisible.value = true
		reqPdcaItemDetail({ id: id }).then((res: any) => {
			if (res.status === 1 && res.datalist) {
				detail.value = res.datalist
				const it = res.datalist.item
				Object.assign(pForm, {
					title: it.title, source_type: it.source_type, level: it.level, dept_name: it.dept_name,
					owner_name: it.owner_name, plan_deadline: it.plan_deadline,
					problem_desc: it.problem_desc || '', root_cause: it.root_cause || '',
					metrics: (res.datalist.metrics || []).map((m: any) => ({
						id: m.id, metric_name: m.metric_name, base_value: num(m.base_value), target_value: num(m.target_value)
					}))
				})
				if (!pForm.metrics.length) pForm.metrics = [newMetric()]
				checkMetrics.value = (res.datalist.metrics || []).map((m: any) => ({
					id: m.id, metric_name: m.metric_name, base_value: num(m.base_value),
					target_value: num(m.target_value), after_value: num(m.after_value)
				}))
				Object.assign(checkForm, { side_effect: it.side_effect || '', check_note: it.check_note || '' })
				Object.assign(closeForm, { saving_amount: it.saving_amount === '' || it.saving_amount === null ? null : Number(it.saving_amount) })
			} else ElMessage.error(res.msg || '加载失败')
		})
	}
	const savePForm = () => {
		submitting.value = true
		reqPdcaItemSave(Object.assign({}, pForm, {
			id: detail.value.item.id, status: 'planning', metrics: JSON.stringify(pForm.metrics || [])
		})).then((res: any) => {
			if (res.status === 1) {
				ElMessage.success('计划已保存')
				openDetailById(detail.value.item.id); refreshAll()
			} else ElMessage.error(res.msg)
		}).finally(() => { submitting.value = false })
	}
	const doTransition = (to: string) => {
		const body: any = { id: detail.value.item.id, to: to }
		if (to === 'acting' || to === 'planning') {
			if (detail.value.item.status === 'checking') {
				body.side_effect = checkForm.side_effect
				body.check_note = checkForm.check_note
				body.check_conclusion = overallConclusion.value
				body.metrics = JSON.stringify((checkMetrics.value || []).map((m: any) => ({ id: m.id, after_value: m.after_value })))
			}
		}
		submitting.value = true
		reqPdcaItemTransition(body).then((res: any) => {
			if (res.status === 1) {
				ElMessage.success('状态已更新')
				if (to === 'acting') detailTab.value = 'A'
				if (to === 'planning' && detail.value.item.status === 'checking') detailTab.value = 'P'
				openDetailById(detail.value.item.id); refreshAll()
			} else ElMessage.error(res.msg)
		}).finally(() => { submitting.value = false })
	}
	const handleClose = () => {
		submitting.value = true
		reqPdcaItemClose({ id: detail.value.item.id, saving_amount: closeForm.saving_amount }).then((res: any) => {
			if (res.status === 1) {
				ElMessage.success('课题已关闭')
				openDetailById(detail.value.item.id); refreshAll()
			} else ElMessage.error(res.msg)
		}).finally(() => { submitting.value = false })
	}

	// 对策
	const actionVisible = ref(false)
	const emptyAction = () => ({ id: 0, item_id: 0, action_desc: '', owner_name: '', deadline: '' })
	const actionForm = ref<any>(emptyAction())
	const openActionForm = (row: any) => {
		const a = emptyAction()
		if (row) { a.id = row.id; a.item_id = row.item_id; a.action_desc = row.action_desc; a.owner_name = row.owner_name; a.deadline = row.deadline }
		else { a.item_id = detail.value.item.id }
		actionForm.value = a
		actionVisible.value = true
	}
	const submitAction = () => {
		const a = actionForm.value
		if (!a.action_desc || !a.action_desc.trim()) { ElMessage.warning('请输入对策内容'); return }
		if (!a.owner_name || !a.owner_name.trim()) { ElMessage.warning('请指定责任人'); return }
		submitting.value = true
		reqPdcaActionSave(Object.assign({}, a)).then((res: any) => {
			if (res.status === 1) { ElMessage.success('已保存'); actionVisible.value = false; openDetailById(detail.value.item.id) }
			else ElMessage.error(res.msg)
		}).finally(() => { submitting.value = false })
	}
	const handleDeleteAction = (row: any) => {
		reqPdcaActionDelete({ id: row.id }).then((res: any) => {
			if (res.status === 1) { ElMessage.success('已删除'); openDetailById(detail.value.item.id) } else ElMessage.error(res.msg)
		})
	}
	const setActionStatus = (row: any, status: string) => {
		reqPdcaActionStatus({ id: row.id, status: status }).then((res: any) => {
			if (res.status === 1) {
				ElMessage.success('已更新')
				if (detail.value) openDetailById(row.item_id)
				loadMy()
			} else ElMessage.error(res.msg)
		})
	}

	// 证据
	const evidenceVisible = ref(false)
	const evidenceRow = ref<any>(null)
	const evidenceText = ref('')
	const evidenceImgs = ref<string[]>([])
	const dragOver = ref(false)
	const MAX_EVIDENCE_SIZE = 5 * 1024 * 1024 // 单个附件上限 5MB
	const IMG_EXT = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']

	const splitImgs = (s: any) => (s ? String(s).split(',').filter(Boolean) : [])
	const apiUrl = (u: string) => (u && (u.indexOf('http') === 0 || u.indexOf('data:') === 0) ? u : api.value + u)
	// 是否为图片（用于缩略图预览，非图片显示为链接）
	const isImg = (u: string) => {
		const name = String(u || '').split('?')[0].toLowerCase()
		return IMG_EXT.some(ext => name.endsWith('.' + ext))
	}
	const fileName = (u: string) => {
		const seg = String(u || '').split('/')
		return decodeURIComponent(seg[seg.length - 1] || '附件')
	}
	// 图片预览列表（只含图片，保证 initial-index 与列表对应）
	const evidenceImgPreviews = computed(() => evidenceImgs.value.filter((u: string) => isImg(u)).map((u: string) => apiUrl(u)))
	const imgPreviewIndex = (u: string) => {
		const list = evidenceImgs.value.filter((x: string) => isImg(x))
		const i = list.indexOf(u)
		return i < 0 ? 0 : i
	}
	// D 执行列表中展示的证据图片预览
	const imgList = (s: any) => splitImgs(s).filter((u: string) => isImg(u)).map((u: string) => apiUrl(u))
	const imgIndexOf = (s: any, u: string) => {
		const list = splitImgs(s).filter((x: string) => isImg(x))
		const i = list.indexOf(u)
		return i < 0 ? 0 : i
	}

	// 上传单个附件（点击选择 / 拖拽 / 粘贴 共用）
	const uploadEvidenceFile = (raw: any) => {
		if (!raw) return
		if (raw.size && raw.size > MAX_EVIDENCE_SIZE) {
			ElMessage.warning(`【${raw.name || '文件'}】超过5MB，已跳过`)
			return
		}
		const fd = new FormData()
		fd.append('file', raw)
		axios.post(`${api.value}/frame/uploadfile1`, fd).then((res: any) => {
			const d = res && res.data
			if (d && d.errno === 0 && d.data && d.data[0]) {
				evidenceImgs.value.push(d.data[0].url)
				ElMessage.success('附件已添加')
			} else {
				ElMessage.error((d && (d.msg || d.data)) || '上传失败')
			}
		}).catch(() => ElMessage.error('上传失败'))
	}
	// el-upload 点击选择：仍走组件上传，这里只做大小校验
	const beforeEvidenceUpload = (raw: any) => {
		if (raw && raw.size && raw.size > MAX_EVIDENCE_SIZE) {
			ElMessage.warning(`【${raw.name || '文件'}】超过5MB，已跳过`)
			return false
		}
		return true
	}
	const onEvidenceImgSuccess = (res: any) => {
		if (res && res.errno === 0 && res.data && res.data[0]) evidenceImgs.value.push(res.data[0].url)
		else ElMessage.error('附件上传失败')
	}
	// 拖拽释放：支持一次拖入多个文件
	const onEvidenceDrop = (e: any) => {
		dragOver.value = false
		const dt = e && e.dataTransfer
		if (!dt) return
		const files = dt.files && dt.files.length ? Array.from(dt.files) : []
		if (!files.length) return
		files.forEach((f: any) => uploadEvidenceFile(f))
	}
	const onDragLeave = (e: any) => {
		// 离开整个拖拽区才取消高亮（避免子元素切换导致闪烁）
		if (e && e.currentTarget && e.relatedTarget && e.currentTarget.contains(e.relatedTarget)) return
		dragOver.value = false
	}
	// Ctrl+V 粘贴上传（仅证据弹窗打开时生效）
	const onEvidencePaste = (e: any) => {
		if (!evidenceVisible.value) return
		const cd = e.clipboardData || (window as any).clipboardData
		if (!cd) return
		let handled = false
		if (cd.items && cd.items.length) {
			for (let i = 0; i < cd.items.length; i++) {
				const it = cd.items[i]
				if (it.kind === 'file') {
					const f = it.getAsFile()
					if (f) { handled = true; uploadEvidenceFile(f) }
				}
			}
		}
		if (!handled && cd.files && cd.files.length) {
			for (let i = 0; i < cd.files.length; i++) {
				handled = true
				uploadEvidenceFile(cd.files[i])
			}
		}
		if (handled) e.preventDefault()
	}
	const removeEvidenceImg = (idx: number) => { evidenceImgs.value.splice(idx, 1) }
	const openEvidence = (row: any) => {
		evidenceRow.value = row
		evidenceText.value = row && row.evidence ? row.evidence : ''
		evidenceImgs.value = splitImgs(row && row.evidence_imgs)
		evidenceVisible.value = true
	}
	const submitEvidence = () => {
		const txt = (evidenceText.value || '').trim()
		if (!txt && evidenceImgs.value.length === 0) { ElMessage.warning('完成证据必填：填写说明或上传图片——无证据不转C'); return }
		submitting.value = true
		reqPdcaActionStatus({
			id: evidenceRow.value.id, status: 'done', evidence: evidenceText.value,
			evidence_imgs: evidenceImgs.value.join(',')
		}).then((res: any) => {
			if (res.status === 1) {
				ElMessage.success('已标记完成')
				evidenceVisible.value = false
				openDetailById(evidenceRow.value.item_id); loadMy()
			} else ElMessage.error(res.msg)
		}).finally(() => { submitting.value = false })
	}

	// 标准
	const stdVisible = ref(false)
	const stdForm = reactive<any>({ std_type: 'SOP', std_code: '', version: '', deploy_scope: '' })
	const submitStandard = () => {
		if (!stdForm.std_code.trim()) { ElMessage.warning('必须填写标准编号——无标准不关闭'); return }
		submitting.value = true
		reqPdcaStandardSave(Object.assign({}, stdForm, { item_id: detail.value.item.id })).then((res: any) => {
			if (res.status === 1) {
				ElMessage.success('标准已登记'); stdVisible.value = false
				stdForm.std_code = ''; stdForm.version = ''; stdForm.deploy_scope = ''
				openDetailById(detail.value.item.id)
			} else ElMessage.error(res.msg)
		}).finally(() => { submitting.value = false })
	}
	const handleDeleteStandard = (row: any) => {
		reqPdcaStandardDelete({ id: row.id }).then((res: any) => {
			if (res.status === 1) { ElMessage.success('已删除'); openDetailById(detail.value.item.id) } else ElMessage.error(res.msg)
		})
	}

	// 下一轮
	const nextVisible = ref(false)
	const nextForm = reactive<any>({ title: '', owner_name: '', dept_name: '', plan_deadline: '', problem_desc: '' })
	const submitNextCycle = () => {
		submitting.value = true
		reqPdcaItemNextCycle(Object.assign({ id: detail.value.item.id }, nextForm)).then((res: any) => {
			if (res.status === 1) {
				ElMessage.success('已生成下一轮课题 ' + (res.datalist ? res.datalist.code : ''))
				nextVisible.value = false
				openDetailById(detail.value.item.id); refreshAll()
			} else ElMessage.error(res.msg)
		}).finally(() => { submitting.value = false })
	}

	const refreshAll = () => { loadList(); loadPool(); loadKanban(); loadReport(); loadMy() }

	onMounted(() => {
		loadDicts(); loadUsers(); loadRole(); refreshAll()
		document.addEventListener('paste', onEvidencePaste)
	})
	onBeforeUnmount(() => {
		document.removeEventListener('paste', onEvidencePaste)
	})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, _toDisplayString(kanban.by_status['draft'] || 0), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(openCount)), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, _toDisplayString(kanban.overdue || 0), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, _toDisplayString(kanban.by_status['closed'] || 0), 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(savingText)), 1)
      ])
    ]),
    _createVNode(_component_el_tabs, {
      modelValue: activeTab.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((activeTab).value = $event)),
      type: "border-card"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "课题列表",
          name: "list"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_el_input, {
                modelValue: searchForm.keyword,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.keyword) = $event)),
                placeholder: "搜索编号/标题/负责人",
                clearable: "",
                onKeyup: _withKeys(loadList, ["enter"]),
                style: {"width":"220px"}
              }, null, 8, ["modelValue", "onKeyup"]),
              _createVNode(_component_el_select, {
                modelValue: searchForm.status,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.status) = $event)),
                placeholder: "状态",
                clearable: "",
                style: {"width":"130px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(statusOptions), (s) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: s.value,
                      label: s.label,
                      value: s.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_select, {
                modelValue: searchForm.source_type,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchForm.source_type) = $event)),
                placeholder: "问题来源",
                clearable: "",
                style: {"width":"130px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dicts.sources, (s) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: s,
                      label: s,
                      value: s
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_select, {
                modelValue: searchForm.level,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchForm.level) = $event)),
                placeholder: "层级",
                clearable: "",
                style: {"width":"110px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dicts.levels, (s) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: s,
                      label: s,
                      value: s
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_switch, {
                modelValue: searchForm.mine,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchForm.mine) = $event)),
                "active-text": "只看我的"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: loadList
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, { onClick: resetSearch }, {
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "success",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (openForm(null)))
              }, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_23, [
              _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                data: listData.value,
                border: "",
                stripe: "",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "code",
                    label: "编号",
                    width: "130"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "title",
                    label: "课题标题",
                    "min-width": "200",
                    "show-overflow-tooltip": ""
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "状态",
                    width: "100",
                    align: "center"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_el_tag, {
                        type: statusMeta[row.status] ? statusMeta[row.status].tag : 'info',
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(statusLabel(row.status)), 1)
                        ]),
                        _: 2
                      }, 1032, ["type"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "逾期",
                    width: "70",
                    align: "center"
                  }, {
                    default: _withCtx(({ row }) => [
                      (Number(row.overdue) === 1)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 0,
                            type: "danger",
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_24
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createElementBlock("span", _hoisted_25, "-"))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "source_type",
                    label: "来源",
                    width: "100",
                    "show-overflow-tooltip": ""
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "level",
                    label: "层级",
                    width: "80"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "owner_name",
                    label: "负责人",
                    width: "90"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "指标",
                    "min-width": "170",
                    "show-overflow-tooltip": ""
                  }, {
                    default: _withCtx(({ row }) => [
                      _createTextVNode(_toDisplayString(row.metric_name || '-') + " ", 1),
                      (row.base_value !== null && row.base_value !== undefined && row.base_value !== '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, "（" + _toDisplayString(row.base_value) + " → " + _toDisplayString(row.target_value) + "）", 1))
                        : _createCommentVNode("", true),
                      (Number(row.metric_count) > 1)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 1,
                            size: "small",
                            type: "info",
                            effect: "plain",
                            style: {"margin-left":"4px"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("共" + _toDisplayString(row.metric_count) + "项", 1)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "对策进度",
                    width: "90",
                    align: "center"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createTextVNode(_toDisplayString(row.action_done) + "/" + _toDisplayString(row.action_total), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "plan_deadline",
                    label: "计划完成",
                    width: "105"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "操作",
                    width: "200",
                    fixed: "right"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "primary",
                        onClick: ($event: any) => (openDetail(row))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_27
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      (canEdit.value && (row.status==='draft'||row.status==='planning'))
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            size: "small",
                            onClick: ($event: any) => (openForm(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_28
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      (canDelete.value && (row.status==='draft'||row.status==='planning'))
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 1,
                            size: "small",
                            type: "danger",
                            onClick: ($event: any) => (handleDeleteItem(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_29
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])), [
                [_directive_loading, loading.value]
              ]),
              _createVNode(_component_el_pagination, {
                background: "",
                layout: "total, sizes, prev, pager, next, jumper",
                total: total.value,
                "page-size": searchForm.page_size,
                "page-sizes": [20,50,100],
                "current-page": currentPage.value,
                onCurrentChange: handlePageChange,
                onSizeChange: handleSizeChange,
                style: {"margin-top":"14px","justify-content":"flex-end"}
              }, null, 8, ["total", "page-size", "current-page"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, { name: "pool" }, {
          label: _withCtx(() => [
            _hoisted_30,
            (kanban.by_status['draft'])
              ? (_openBlock(), _createBlock(_component_el_badge, {
                  key: 0,
                  value: kanban.by_status['draft'],
                  style: {"margin-left":"4px"}
                }, null, 8, ["value"]))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createVNode(_component_el_button, {
                type: "success",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (openForm(null)))
              }, {
                default: _withCtx(() => [
                  _hoisted_33
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_34, [
              _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                data: poolData.value,
                border: "",
                stripe: "",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "code",
                    label: "编号",
                    width: "130"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "title",
                    label: "问题标题",
                    "min-width": "220",
                    "show-overflow-tooltip": ""
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "source_type",
                    label: "来源",
                    width: "100"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "create_by",
                    label: "提出人",
                    width: "90"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "create_time",
                    label: "提出时间",
                    width: "160"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "操作",
                    width: "200",
                    fixed: "right"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "primary",
                        onClick: ($event: any) => (openDetail(row))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_35
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      (canEdit.value)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            size: "small",
                            onClick: ($event: any) => (openForm(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_36
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      (canDelete.value)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 1,
                            size: "small",
                            type: "danger",
                            onClick: ($event: any) => (handleDeleteItem(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_37
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])), [
                [_directive_loading, poolLoading.value]
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, { name: "my" }, {
          label: _withCtx(() => [
            _hoisted_38,
            (myTasks.value.length)
              ? (_openBlock(), _createBlock(_component_el_badge, {
                  key: 0,
                  value: myTasks.value.length,
                  style: {"margin-left":"4px"}
                }, null, 8, ["value"]))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_39, [
              _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                data: myTasks.value,
                border: "",
                stripe: "",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "item_code",
                    label: "课题编号",
                    width: "130"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "item_title",
                    label: "课题标题",
                    "min-width": "180",
                    "show-overflow-tooltip": ""
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "action_desc",
                    label: "我的对策任务",
                    "min-width": "200",
                    "show-overflow-tooltip": ""
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "deadline",
                    label: "截止日期",
                    width: "105"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "状态",
                    width: "90",
                    align: "center"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_el_tag, {
                        type: row.status==='doing' ? 'warning' : 'info',
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(actionStatusLabel(row.status)), 1)
                        ]),
                        _: 2
                      }, 1032, ["type"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "操作",
                    width: "220",
                    fixed: "right"
                  }, {
                    default: _withCtx(({ row }) => [
                      (row.status==='todo')
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            size: "small",
                            onClick: ($event: any) => (setActionStatus(row, 'doing'))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_40
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "success",
                        onClick: ($event: any) => (openEvidence(row))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_41
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "primary",
                        onClick: ($event: any) => (openDetailById(row.item_id))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_42
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])), [
                [_directive_loading, myLoading.value]
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "看板",
          name: "kanban"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_43, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(statusOptions), (s) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "kanban-col",
                  key: s.value,
                  onClick: ($event: any) => (jumpStatus(s.value))
                }, [
                  _createElementVNode("div", _hoisted_45, _toDisplayString(s.label), 1),
                  _createElementVNode("div", {
                    class: "k-count",
                    style: _normalizeStyle({ color: s.color })
                  }, _toDisplayString(kanban.by_status[s.value] || 0), 5)
                ], 8, _hoisted_44))
              }), 128)),
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("div", _hoisted_48, _toDisplayString(kanban.overdue || 0), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_49, "点击卡片跳转到课题列表对应状态。我的待办课题 " + _toDisplayString(kanban.my_open || 0) + " 个。", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "报表",
          name: "report"
        }, {
          default: _withCtx(() => [
            (report.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _createVNode(_component_el_descriptions, {
                    title: "经营报表（月度经营会议题）",
                    column: 4,
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_descriptions_item, { label: "课题总数" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(report.value.total), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "已关闭" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(report.value.closed), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "进行中" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(report.value.open), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "问题池" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(report.value.pool), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "闭环率" }, {
                        default: _withCtx(() => [
                          _createElementVNode("b", _hoisted_51, _toDisplayString(report.value.closure_rate) + "%", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "关闭准时率" }, {
                        default: _withCtx(() => [
                          _createElementVNode("b", {
                            style: _normalizeStyle({color: report.value.on_time_rate >= 80 ? '#67c23a' : '#f56c6c'})
                          }, _toDisplayString(report.value.on_time_rate) + "%", 5)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "逾期课题" }, {
                        default: _withCtx(() => [
                          _createElementVNode("b", _hoisted_52, _toDisplayString(report.value.overdue), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "节约金额" }, {
                        default: _withCtx(() => [
                          _createTextVNode("¥" + _toDisplayString(report.value.saving_total), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, {
                    gutter: 16,
                    style: {"margin-top":"16px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_53, [
                            _hoisted_54,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(report.value.by_source, (c, k) => {
                              return (_openBlock(), _createBlock(_component_el_tag, {
                                key: k,
                                style: {"margin":"4px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(k) + ": " + _toDisplayString(c), 1)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_55, [
                            _hoisted_56,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(report.value.by_level, (c, k) => {
                              return (_openBlock(), _createBlock(_component_el_tag, {
                                key: k,
                                type: "warning",
                                style: {"margin":"4px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(k) + ": " + _toDisplayString(c), 1)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: formVisible.value,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formVisible).value = $event)),
      title: form.value.id ? '完善课题（立项）' : '录入课题',
      width: "720px",
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[17] || (_cache[17] = ($event: any) => (formVisible.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_65
          ]),
          _: 1
        }),
        (!form.value.id)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: _cache[18] || (_cache[18] = ($event: any) => (submitForm('draft'))),
              loading: submitting.value
            }, {
              default: _withCtx(() => [
                _hoisted_66
              ]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[19] || (_cache[19] = ($event: any) => (submitForm('planning'))),
          loading: submitting.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(form.value.id ? '保存并立项' : '直接立项'), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: form.value,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, null, {
                      label: _withCtx(() => [
                        _hoisted_57,
                        _hoisted_58
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.value.title,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.title) = $event)),
                          placeholder: "一句话说清问题",
                          maxlength: "200"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "问题来源" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: form.value.source_type,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.source_type) = $event)),
                          style: {"width":"100%"},
                          clearable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dicts.sources, (s) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: s,
                                label: s,
                                value: s
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "课题层级" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: form.value.level,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.level) = $event)),
                          style: {"width":"100%"},
                          clearable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dicts.levels, (s) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: s,
                                label: s,
                                value: s
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "责任部门" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.value.dept_name,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.dept_name) = $event)),
                          maxlength: "100"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "课题负责人" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: form.value.owner_name,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.owner_name) = $event)),
                          style: {"width":"100%"},
                          clearable: "",
                          filterable: "",
                          "allow-create": "",
                          "default-first-option": "",
                          placeholder: "可输入搜索选择"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userOptions.value, (u) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: u.id,
                                label: u.name,
                                value: u.name
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "计划完成" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: form.value.plan_deadline,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.plan_deadline) = $event)),
                          type: "date",
                          "value-format": "YYYY-MM-DD",
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "问题陈述" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.value.problem_desc,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.problem_desc) = $event)),
                          type: "textarea",
                          rows: 3,
                          placeholder: "现状 + 差距，用数据描述问题"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "根因分析" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.value.root_cause,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value.root_cause) = $event)),
                          type: "textarea",
                          rows: 3,
                          placeholder: "5Why 结论：连续追问为什么，直到系统原因"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "验证指标" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_59, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.metrics, (m, idx) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: idx,
                              style: {"display":"flex","gap":"8px","align-items":"center","margin-bottom":"8px"}
                            }, [
                              _createElementVNode("span", _hoisted_60, _toDisplayString(idx + 1), 1),
                              _createVNode(_component_el_input, {
                                modelValue: m.metric_name,
                                "onUpdate:modelValue": ($event: any) => ((m.metric_name) = $event),
                                placeholder: "指标名，如: 盘点差异率%",
                                style: {"flex":"1 1 auto","min-width":"150px"}
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              _createVNode(_component_el_input_number, {
                                modelValue: m.base_value,
                                "onUpdate:modelValue": ($event: any) => ((m.base_value) = $event),
                                controls: false,
                                placeholder: "基线值",
                                style: {"width":"130px"}
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              _createVNode(_component_el_input_number, {
                                modelValue: m.target_value,
                                "onUpdate:modelValue": ($event: any) => ((m.target_value) = $event),
                                controls: false,
                                placeholder: "目标值",
                                style: {"width":"130px"}
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              _createVNode(_component_el_button, {
                                type: "danger",
                                link: "",
                                onClick: ($event: any) => (removeMetricRow(form.value.metrics, idx))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_61
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]))
                          }), 128)),
                          _createVNode(_component_el_button, {
                            type: "primary",
                            link: "",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (addMetricRow(form.value.metrics)))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_62
                            ]),
                            _: 1
                          }),
                          _hoisted_63
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _hoisted_64
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_drawer, {
      modelValue: detailVisible.value,
      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((detailVisible).value = $event)),
      size: "72%",
      title: detail.value ? (detail.value.item.code + ' ' + detail.value.item.title) : '课题详情',
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        (detail.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
              _createElementVNode("div", _hoisted_68, [
                _createVNode(_component_el_tag, {
                  type: statusMeta[detail.value.item.status] ? statusMeta[detail.value.item.status].tag : 'info'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(statusLabel(detail.value.item.status)), 1)
                  ]),
                  _: 1
                }, 8, ["type"]),
                (Number(detail.value.item.overdue)===1)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      type: "danger"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_69
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_tag, {
                  type: "info",
                  effect: "plain"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(detail.value.item.owner_name || '未指派'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tag, {
                  type: "info",
                  effect: "plain"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(detail.value.item.dept_name || '-'), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("span", _hoisted_70, "计划完成: " + _toDisplayString(detail.value.item.plan_deadline || '-'), 1)
              ]),
              _createVNode(_component_el_steps, {
                class: "drawer-steps",
                active: _unref(stepActive),
                "finish-status": "success",
                simple: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_step, { title: "P 计划" }),
                  _createVNode(_component_el_step, { title: "D 执行" }),
                  _createVNode(_component_el_step, { title: "C 检查" }),
                  _createVNode(_component_el_step, { title: "A 处理" })
                ]),
                _: 1
              }, 8, ["active"]),
              (detail.value.parent && detail.value.parent.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                    _createTextVNode(" 课题链：上一轮 " + _toDisplayString(detail.value.parent.code) + "（" + _toDisplayString(statusLabel(detail.value.parent.status)) + "） ", 1),
                    (detail.value.children && detail.value.children.length)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_72, [
                          _hoisted_73,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.children, (c) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: c.id,
                              style: {"margin-right":"8px","cursor":"pointer","text-decoration":"underline"},
                              onClick: ($event: any) => (openDetailById(c.id))
                            }, _toDisplayString(c.code) + "（" + _toDisplayString(statusLabel(c.status)) + "）", 9, _hoisted_74))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_tabs, {
                modelValue: detailTab.value,
                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((detailTab).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tab_pane, {
                    label: "P 计划",
                    name: "P"
                  }, {
                    default: _withCtx(() => [
                      (!_unref(pEditable))
                        ? (_openBlock(), _createBlock(_component_el_descriptions, {
                            key: 0,
                            column: 2,
                            border: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_descriptions_item, {
                                label: "课题标题",
                                span: 2
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(detail.value.item.title), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_descriptions_item, { label: "问题来源" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(detail.value.item.source_type || '-'), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_descriptions_item, { label: "课题层级" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(detail.value.item.level || '-'), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_descriptions_item, {
                                label: "问题陈述",
                                span: 2
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(detail.value.item.problem_desc || '-'), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_descriptions_item, {
                                label: "根因分析",
                                span: 2
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(detail.value.item.root_cause || '-'), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_descriptions_item, {
                                label: "验证指标",
                                span: 2
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_table, {
                                    data: detail.value.metrics,
                                    size: "small",
                                    border: "",
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_table_column, {
                                        type: "index",
                                        label: "#",
                                        width: "45"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        prop: "metric_name",
                                        label: "指标名",
                                        "min-width": "140",
                                        "show-overflow-tooltip": ""
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "基线 → 目标",
                                        width: "150"
                                      }, {
                                        default: _withCtx(({ row }) => [
                                          _createTextVNode(_toDisplayString(row.base_value ?? '-') + " → " + _toDisplayString(row.target_value ?? '-'), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["data"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createElementBlock("div", _hoisted_75, [
                            _createVNode(_component_el_form, {
                              model: pForm,
                              "label-width": "100px"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_row, { gutter: 12 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, { span: 12 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_form_item, { label: "课题标题" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_input, {
                                              modelValue: pForm.title,
                                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((pForm.title) = $event))
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, { span: 12 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_form_item, { label: "课题负责人" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_input, {
                                              modelValue: pForm.owner_name,
                                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((pForm.owner_name) = $event))
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, { span: 12 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_form_item, { label: "问题来源" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_select, {
                                              modelValue: pForm.source_type,
                                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((pForm.source_type) = $event)),
                                              style: {"width":"100%"},
                                              clearable: ""
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dicts.sources, (s) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: s,
                                                    label: s,
                                                    value: s
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, { span: 12 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_form_item, { label: "课题层级" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_select, {
                                              modelValue: pForm.level,
                                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((pForm.level) = $event)),
                                              style: {"width":"100%"},
                                              clearable: ""
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dicts.levels, (s) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: s,
                                                    label: s,
                                                    value: s
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, { span: 12 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_form_item, { label: "责任部门" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_input, {
                                              modelValue: pForm.dept_name,
                                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((pForm.dept_name) = $event))
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, { span: 12 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_form_item, { label: "计划完成" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_date_picker, {
                                              modelValue: pForm.plan_deadline,
                                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((pForm.plan_deadline) = $event)),
                                              type: "date",
                                              "value-format": "YYYY-MM-DD",
                                              style: {"width":"100%"}
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, { span: 24 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_form_item, { label: "问题陈述" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_input, {
                                              modelValue: pForm.problem_desc,
                                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((pForm.problem_desc) = $event)),
                                              type: "textarea",
                                              rows: 3
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, { span: 24 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_form_item, { label: "根因分析" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_input, {
                                              modelValue: pForm.root_cause,
                                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((pForm.root_cause) = $event)),
                                              type: "textarea",
                                              rows: 3,
                                              placeholder: "5Why 结论"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, { span: 24 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_form_item, { label: "验证指标" }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_76, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pForm.metrics, (m, idx) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: idx,
                                                  style: {"display":"flex","gap":"8px","align-items":"center","margin-bottom":"8px"}
                                                }, [
                                                  _createElementVNode("span", _hoisted_77, _toDisplayString(idx + 1), 1),
                                                  _createVNode(_component_el_input, {
                                                    modelValue: m.metric_name,
                                                    "onUpdate:modelValue": ($event: any) => ((m.metric_name) = $event),
                                                    placeholder: "指标名",
                                                    style: {"flex":"1 1 auto","min-width":"140px"}
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                  _createVNode(_component_el_input_number, {
                                                    modelValue: m.base_value,
                                                    "onUpdate:modelValue": ($event: any) => ((m.base_value) = $event),
                                                    controls: false,
                                                    placeholder: "基线值",
                                                    style: {"width":"120px"}
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                  _createVNode(_component_el_input_number, {
                                                    modelValue: m.target_value,
                                                    "onUpdate:modelValue": ($event: any) => ((m.target_value) = $event),
                                                    controls: false,
                                                    placeholder: "目标值",
                                                    style: {"width":"120px"}
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                  _createVNode(_component_el_button, {
                                                    type: "danger",
                                                    link: "",
                                                    onClick: ($event: any) => (removeMetricRow(pForm.metrics, idx))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_78
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"])
                                                ]))
                                              }), 128)),
                                              _createVNode(_component_el_button, {
                                                type: "primary",
                                                link: "",
                                                onClick: _cache[29] || (_cache[29] = ($event: any) => (addMetricRow(pForm.metrics)))
                                              }, {
                                                default: _withCtx(() => [
                                                  _hoisted_79
                                                ]),
                                                _: 1
                                              })
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["model"]),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              size: "small",
                              onClick: savePForm,
                              loading: submitting.value
                            }, {
                              default: _withCtx(() => [
                                _hoisted_80
                              ]),
                              _: 1
                            }, 8, ["loading"])
                          ])),
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("div", _hoisted_82, [
                          _hoisted_83,
                          (_unref(pEditable) && canEdit.value)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                size: "small",
                                type: "primary",
                                onClick: _cache[30] || (_cache[30] = ($event: any) => (openActionForm(null)))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_84
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_el_table, {
                          data: detail.value.actions,
                          border: "",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              type: "index",
                              label: "#",
                              width: "45"
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "action_desc",
                              label: "对策内容",
                              "min-width": "200",
                              "show-overflow-tooltip": ""
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "owner_name",
                              label: "责任人",
                              width: "90"
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "deadline",
                              label: "截止日期",
                              width: "100"
                            }),
                            (_unref(pEditable) && canEdit.value)
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 0,
                                  label: "操作",
                                  width: "140"
                                }, {
                                  default: _withCtx(({ row }) => [
                                    _createVNode(_component_el_button, {
                                      size: "small",
                                      onClick: ($event: any) => (openActionForm(row))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_85
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_el_button, {
                                      size: "small",
                                      type: "danger",
                                      onClick: ($event: any) => (handleDeleteAction(row))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_86
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ]),
                      (detail.value.item.status==='planning')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                            _hoisted_88,
                            (canEdit.value)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  type: "warning",
                                  size: "small",
                                  style: {"margin-left":"10px"},
                                  onClick: _cache[31] || (_cache[31] = ($event: any) => (doTransition('doing'))),
                                  loading: submitting.value
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_89
                                  ]),
                                  _: 1
                                }, 8, ["loading"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_tab_pane, {
                    label: "D 执行",
                    name: "D"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table, {
                        data: detail.value.actions,
                        border: "",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            type: "index",
                            label: "#",
                            width: "45"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "action_desc",
                            label: "对策内容",
                            "min-width": "180",
                            "show-overflow-tooltip": ""
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "owner_name",
                            label: "责任人",
                            width: "90"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "deadline",
                            label: "截止日期",
                            width: "100"
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "状态",
                            width: "90",
                            align: "center"
                          }, {
                            default: _withCtx(({ row }) => [
                              _createVNode(_component_el_tag, {
                                type: row.status==='done' ? 'success' : (row.status==='doing' ? 'warning' : (row.status==='cancelled' ? 'info' : '')),
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(actionStatusLabel(row.status)), 1)
                                ]),
                                _: 2
                              }, 1032, ["type"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "完成证据",
                            "min-width": "180"
                          }, {
                            default: _withCtx(({ row }) => [
                              (row.evidence)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_90, _toDisplayString(row.evidence), 1))
                                : _createCommentVNode("", true),
                              (row.evidence_imgs)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(splitImgs(row.evidence_imgs), (u, i) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                                        (isImg(u))
                                          ? (_openBlock(), _createBlock(_component_el_image, {
                                              key: 0,
                                              src: apiUrl(u),
                                              "preview-src-list": imgList(row.evidence_imgs),
                                              "initial-index": imgIndexOf(row.evidence_imgs, u),
                                              fit: "cover",
                                              "preview-teleported": "",
                                              style: {"width":"42px","height":"42px","border-radius":"4px","border":"1px solid #eee","cursor":"pointer"}
                                            }, null, 8, ["src", "preview-src-list", "initial-index"]))
                                          : (_openBlock(), _createElementBlock("a", {
                                              key: 1,
                                              href: apiUrl(u),
                                              target: "_blank",
                                              style: {"font-size":"12px","color":"#409EFF"}
                                            }, _toDisplayString(fileName(u)), 9, _hoisted_92))
                                      ], 64))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true),
                              (!row.evidence && !row.evidence_imgs)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_93, "-"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "done_at",
                            label: "完成时间",
                            width: "150"
                          }),
                          (detail.value.item.status==='doing' && canEdit.value)
                            ? (_openBlock(), _createBlock(_component_el_table_column, {
                                key: 0,
                                label: "操作",
                                width: "200"
                              }, {
                                default: _withCtx(({ row }) => [
                                  (row.status==='todo')
                                    ? (_openBlock(), _createBlock(_component_el_button, {
                                        key: 0,
                                        size: "small",
                                        onClick: ($event: any) => (setActionStatus(row, 'doing'))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_94
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  (row.status!=='done' && row.status!=='cancelled')
                                    ? (_openBlock(), _createBlock(_component_el_button, {
                                        key: 1,
                                        size: "small",
                                        type: "success",
                                        onClick: ($event: any) => (openEvidence(row))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_95
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  (row.status==='todo')
                                    ? (_openBlock(), _createBlock(_component_el_button, {
                                        key: 2,
                                        size: "small",
                                        type: "info",
                                        onClick: ($event: any) => (setActionStatus(row, 'cancelled'))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_96
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["data"]),
                      (detail.value.item.status==='doing')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                            _hoisted_98,
                            (canEdit.value)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  type: "warning",
                                  size: "small",
                                  style: {"margin-left":"10px"},
                                  onClick: _cache[32] || (_cache[32] = ($event: any) => (doTransition('checking'))),
                                  loading: submitting.value
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_99
                                  ]),
                                  _: 1
                                }, 8, ["loading"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_tab_pane, {
                    label: "C 检查",
                    name: "C"
                  }, {
                    default: _withCtx(() => [
                      (detail.value.item.status==='checking')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                            _hoisted_101,
                            _createVNode(_component_el_table, {
                              data: checkMetrics.value,
                              size: "small",
                              border: "",
                              style: {"width":"100%","margin-bottom":"12px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_table_column, {
                                  type: "index",
                                  label: "#",
                                  width: "45"
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "metric_name",
                                  label: "指标",
                                  "min-width": "130",
                                  "show-overflow-tooltip": ""
                                }),
                                _createVNode(_component_el_table_column, {
                                  label: "基线",
                                  width: "90"
                                }, {
                                  default: _withCtx(({ row }) => [
                                    _createTextVNode(_toDisplayString(row.base_value ?? '-'), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  label: "目标",
                                  width: "90"
                                }, {
                                  default: _withCtx(({ row }) => [
                                    _createTextVNode(_toDisplayString(row.target_value ?? '-'), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  label: "实测值(改善后)",
                                  width: "150"
                                }, {
                                  default: _withCtx(({ row }) => [
                                    _createVNode(_component_el_input_number, {
                                      modelValue: row.after_value,
                                      "onUpdate:modelValue": ($event: any) => ((row.after_value) = $event),
                                      controls: false,
                                      size: "small",
                                      style: {"width":"100%"}
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  label: "判定",
                                  width: "90",
                                  align: "center"
                                }, {
                                  default: _withCtx(({ row }) => [
                                    (metricJudge(row)==='达标')
                                      ? (_openBlock(), _createBlock(_component_el_tag, {
                                          key: 0,
                                          type: "success",
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_102
                                          ]),
                                          _: 1
                                        }))
                                      : (metricJudge(row)==='未达标')
                                        ? (_openBlock(), _createBlock(_component_el_tag, {
                                            key: 1,
                                            type: "danger",
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_103
                                            ]),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_104, "待录入"))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["data"]),
                            _createElementVNode("div", _hoisted_105, [
                              _hoisted_106,
                              _createVNode(_component_el_tag, { type: _unref(overallTagType) }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(overallConclusion) || '待录入实测值'), 1)
                                ]),
                                _: 1
                              }, 8, ["type"])
                            ]),
                            _createVNode(_component_el_form, {
                              model: checkForm,
                              "label-width": "100px"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, { label: "副作用检查" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: checkForm.side_effect,
                                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((checkForm.side_effect) = $event)),
                                      placeholder: "其他关联指标是否恶化？无则填'无'"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "检查说明" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: checkForm.check_note,
                                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((checkForm.check_note) = $event)),
                                      type: "textarea",
                                      rows: 2,
                                      placeholder: "未达标必填原因；达标简述验证方式与观察周期"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["model"]),
                            (canEdit.value)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  type: "success",
                                  disabled: !_unref(canEnterActing),
                                  onClick: _cache[35] || (_cache[35] = ($event: any) => (doTransition('acting'))),
                                  loading: submitting.value
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_107
                                  ]),
                                  _: 1
                                }, 8, ["disabled", "loading"]))
                              : _createCommentVNode("", true),
                            (canEdit.value)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 1,
                                  type: "danger",
                                  onClick: _cache[36] || (_cache[36] = ($event: any) => (doTransition('planning'))),
                                  loading: submitting.value
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_108
                                  ]),
                                  _: 1
                                }, 8, ["loading"]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_109, [
                            _createVNode(_component_el_table, {
                              data: detail.value.metrics,
                              size: "small",
                              border: "",
                              style: {"width":"100%","margin-bottom":"12px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_table_column, {
                                  type: "index",
                                  label: "#",
                                  width: "45"
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "metric_name",
                                  label: "指标",
                                  "min-width": "120",
                                  "show-overflow-tooltip": ""
                                }),
                                _createVNode(_component_el_table_column, {
                                  label: "基线",
                                  width: "80"
                                }, {
                                  default: _withCtx(({ row }) => [
                                    _createTextVNode(_toDisplayString(row.base_value ?? '-'), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  label: "目标",
                                  width: "80"
                                }, {
                                  default: _withCtx(({ row }) => [
                                    _createTextVNode(_toDisplayString(row.target_value ?? '-'), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  label: "实测值",
                                  width: "90"
                                }, {
                                  default: _withCtx(({ row }) => [
                                    _createTextVNode(_toDisplayString(row.after_value ?? '-'), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  label: "判定",
                                  width: "90",
                                  align: "center"
                                }, {
                                  default: _withCtx(({ row }) => [
                                    (row.check_conclusion==='达标')
                                      ? (_openBlock(), _createBlock(_component_el_tag, {
                                          key: 0,
                                          type: "success",
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_110
                                          ]),
                                          _: 1
                                        }))
                                      : (row.check_conclusion==='未达标')
                                        ? (_openBlock(), _createBlock(_component_el_tag, {
                                            key: 1,
                                            type: "danger",
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_111
                                            ]),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_112, _toDisplayString(row.check_conclusion || '-'), 1))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["data"]),
                            _createVNode(_component_el_descriptions, {
                              column: 1,
                              border: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_descriptions_item, { label: "整体检查结论" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(detail.value.item.check_conclusion || '-'), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_descriptions_item, { label: "副作用检查" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(detail.value.item.side_effect || '-'), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_descriptions_item, { label: "检查说明" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(detail.value.item.check_note || '-'), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_tab_pane, {
                    label: "A 处理",
                    name: "A"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_113, [
                        _hoisted_114,
                        ((detail.value.item.status==='acting') && canEdit.value)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              size: "small",
                              type: "primary",
                              onClick: _cache[37] || (_cache[37] = ($event: any) => (stdVisible.value=true))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_115
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_el_table, {
                        data: detail.value.standards,
                        border: "",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "std_type",
                            label: "类型",
                            width: "80"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "std_code",
                            label: "标准编号",
                            width: "140"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "version",
                            label: "版本",
                            width: "80"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "deploy_scope",
                            label: "水平展开范围",
                            "min-width": "160",
                            "show-overflow-tooltip": ""
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "create_by",
                            label: "登记人",
                            width: "90"
                          }),
                          (detail.value.item.status==='acting' && canEdit.value)
                            ? (_openBlock(), _createBlock(_component_el_table_column, {
                                key: 0,
                                label: "操作",
                                width: "90"
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createVNode(_component_el_button, {
                                    size: "small",
                                    type: "danger",
                                    onClick: ($event: any) => (handleDeleteStandard(row))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_116
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["data"]),
                      (detail.value.item.status==='acting')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                            _createVNode(_component_el_form, {
                              "label-width": "100px",
                              inline: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, { label: "节约金额" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input_number, {
                                      modelValue: closeForm.saving_amount,
                                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((closeForm.saving_amount) = $event)),
                                      controls: false,
                                      placeholder: "元",
                                      style: {"width":"180px"}
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (canEdit.value)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  type: "success",
                                  onClick: handleClose,
                                  loading: submitting.value
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_118
                                  ]),
                                  _: 1
                                }, 8, ["loading"]))
                              : _createCommentVNode("", true),
                            (canEdit.value)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 1,
                                  type: "warning",
                                  onClick: _cache[39] || (_cache[39] = ($event: any) => (nextVisible.value=true))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_119
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _hoisted_120
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: actionVisible.value,
      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((actionVisible).value = $event)),
      title: actionForm.value.id ? '编辑对策' : '新增对策',
      width: "560px",
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[45] || (_cache[45] = ($event: any) => (actionVisible.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_125
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitAction,
          loading: submitting.value
        }, {
          default: _withCtx(() => [
            _hoisted_126
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: actionForm.value,
          "label-width": "90px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [
                _hoisted_121,
                _hoisted_122
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: actionForm.value.action_desc,
                  "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((actionForm.value.action_desc) = $event)),
                  type: "textarea",
                  rows: 3,
                  maxlength: "500"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [
                _hoisted_123,
                _hoisted_124
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: actionForm.value.owner_name,
                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((actionForm.value.owner_name) = $event)),
                  style: {"width":"100%"},
                  clearable: "",
                  filterable: "",
                  "allow-create": "",
                  "default-first-option": "",
                  placeholder: "可输入搜索选择责任人"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userOptions.value, (u) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: u.id,
                        label: u.name,
                        value: u.name
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "截止日期" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: actionForm.value.deadline,
                  "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((actionForm.value.deadline) = $event)),
                  type: "date",
                  "value-format": "YYYY-MM-DD",
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: evidenceVisible.value,
      "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((evidenceVisible).value = $event)),
      title: "标记完成 · 完成证据",
      width: "560px",
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[50] || (_cache[50] = ($event: any) => (evidenceVisible.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_136
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "success",
          onClick: submitEvidence,
          loading: submitting.value
        }, {
          default: _withCtx(() => [
            _hoisted_137
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_127, "对策：" + _toDisplayString(evidenceRow.value ? evidenceRow.value.action_desc : ''), 1),
        _createVNode(_component_el_input, {
          modelValue: evidenceText.value,
          "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((evidenceText).value = $event)),
          type: "textarea",
          rows: 3,
          placeholder: "单据号 / 数据说明（可选，可配合图片）—— 无证据不转C"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_128, [
          _hoisted_129,
          _createElementVNode("div", {
            style: _normalizeStyle([{"border":"1px dashed #d9d9d9","border-radius":"6px","padding":"10px","transition":"all .15s"}, dragOver.value ? { borderColor:'#409eff', background:'#f0f7ff' } : {}]),
            onDragover: _cache[48] || (_cache[48] = _withModifiers(($event: any) => (dragOver.value = true), ["prevent"])),
            onDragenter: _cache[49] || (_cache[49] = _withModifiers(($event: any) => (dragOver.value = true), ["prevent"])),
            onDragleave: _withModifiers(onDragLeave, ["prevent"]),
            onDrop: _withModifiers(onEvidenceDrop, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_131, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(evidenceImgs.value, (u, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: idx,
                  style: {"position":"relative","width":"88px","height":"88px"}
                }, [
                  (isImg(u))
                    ? (_openBlock(), _createBlock(_component_el_image, {
                        key: 0,
                        src: apiUrl(u),
                        "preview-src-list": _unref(evidenceImgPreviews),
                        "initial-index": imgPreviewIndex(u),
                        fit: "cover",
                        "preview-teleported": "",
                        style: {"width":"88px","height":"88px","border-radius":"6px","border":"1px solid #eee","cursor":"pointer"}
                      }, null, 8, ["src", "preview-src-list", "initial-index"]))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: apiUrl(u),
                        target: "_blank",
                        style: {"display":"flex","align-items":"center","justify-content":"center","width":"88px","height":"88px","border":"1px solid #eee","border-radius":"6px","padding":"4px","font-size":"12px","color":"#409EFF","word-break":"break-all","text-align":"center"}
                      }, _toDisplayString(fileName(u)), 9, _hoisted_132)),
                  _createVNode(_component_el_button, {
                    circle: "",
                    size: "small",
                    type: "danger",
                    style: {"position":"absolute","top":"-8px","right":"-8px","width":"20px","height":"20px","padding":"0"},
                    onClick: ($event: any) => (removeEvidenceImg(idx))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_133
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              }), 128)),
              _createVNode(_component_el_upload, {
                action: `${api.value}/frame/uploadfile1`,
                "show-file-list": false,
                multiple: "",
                "before-upload": beforeEvidenceUpload,
                "on-success": onEvidenceImgSuccess
              }, {
                default: _withCtx(() => [
                  _hoisted_134
                ]),
                _: 1
              }, 8, ["action"])
            ]),
            (evidenceImgs.value.length===0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_135, " 将文件拖拽到此处，或按 Ctrl+V 粘贴截图 "))
              : _createCommentVNode("", true)
          ], 44, _hoisted_130)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: stdVisible.value,
      "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((stdVisible).value = $event)),
      title: "登记标准化产出",
      width: "560px",
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[56] || (_cache[56] = ($event: any) => (stdVisible.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_140
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitStandard,
          loading: submitting.value
        }, {
          default: _withCtx(() => [
            _hoisted_141
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: stdForm,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "标准类型" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: stdForm.std_type,
                  "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((stdForm.std_type) = $event)),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dicts.std_types, (t) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: t,
                        label: t,
                        value: t
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [
                _hoisted_138,
                _hoisted_139
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: stdForm.std_code,
                  "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((stdForm.std_code) = $event)),
                  placeholder: "如 SOP-CK-012",
                  maxlength: "64"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "新版本号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: stdForm.version,
                  "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((stdForm.version) = $event)),
                  placeholder: "如 V2.0",
                  maxlength: "16"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "水平展开" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: stdForm.deploy_scope,
                  "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((stdForm.deploy_scope) = $event)),
                  type: "textarea",
                  rows: 2,
                  placeholder: "复制到哪些仓库/工序/岗位"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: nextVisible.value,
      "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((nextVisible).value = $event)),
      title: "生成下一轮课题（课题链）",
      width: "560px",
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[63] || (_cache[63] = ($event: any) => (nextVisible.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_145
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "warning",
          onClick: submitNextCycle,
          loading: submitting.value
        }, {
          default: _withCtx(() => [
            _hoisted_146
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: nextForm,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [
                _hoisted_142,
                _hoisted_143
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: nextForm.title,
                  "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((nextForm.title) = $event)),
                  maxlength: "200"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "负责人" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: nextForm.owner_name,
                  "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((nextForm.owner_name) = $event)),
                  style: {"width":"100%"},
                  clearable: "",
                  filterable: "",
                  "allow-create": "",
                  "default-first-option": "",
                  placeholder: "可输入搜索选择负责人"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userOptions.value, (u) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: u.id,
                        label: u.name,
                        value: u.name
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "责任部门" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: nextForm.dept_name,
                  "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((nextForm.dept_name) = $event)),
                  maxlength: "100"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "计划完成" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: nextForm.plan_deadline,
                  "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((nextForm.plan_deadline) = $event)),
                  type: "date",
                  "value-format": "YYYY-MM-DD",
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "问题陈述" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: nextForm.problem_desc,
                  "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((nextForm.problem_desc) = $event)),
                  type: "textarea",
                  rows: 2
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _hoisted_144
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})